import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "232",
  height: "82",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "m157.083 38.39-25.25-23.968q-1.166-1.107-2.833-1.107-1.666 0-2.833 1.107-1.083 1.027-1.084 2.61 0 1.582 1.084 2.69l18.583 17.56h-67.5a3.94 3.94 0 0 0-2.75 1.068q-1.166 1.068-1.166 2.65t1.124 2.65 2.792 1.068h67.5l-18.5 17.56q-1.167 1.108-1.167 2.69t1.167 2.61a3.97 3.97 0 0 0 2.75 1.108q.75 0 1.5-.277.75-.278 1.333-.83l25.25-23.969q1.084-1.107 1.084-2.61t-1.084-2.61"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }